import type { NationalTeamHit } from 'lib/algolia';

import { Suggestion } from '../Suggestion';

interface Props {
  hit: NationalTeamHit;
  isHighlighted: boolean;
}

export const NationalTeamSuggestion = ({ hit, isHighlighted }: Props) => {
  return (
    <Suggestion
      isHighlighted={isHighlighted}
      renderAvatar={Img => (
        <Img src={hit.pictureUrl} alt={hit.name} isContain />
      )}
      primary={hit.name}
    />
  );
};
